import { render, staticRenderFns } from "./PublicHoliday.vue?vue&type=template&id=0b502c6a&scoped=true&"
import script from "./PublicHoliday.vue?vue&type=script&lang=js&"
export * from "./PublicHoliday.vue?vue&type=script&lang=js&"
import style0 from "./PublicHoliday.vue?vue&type=style&index=0&id=0b502c6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b502c6a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VList,VListItem,VListItemTitle,VMenu,VSheet})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b502c6a')) {
      api.createRecord('0b502c6a', component.options)
    } else {
      api.reload('0b502c6a', component.options)
    }
    module.hot.accept("./PublicHoliday.vue?vue&type=template&id=0b502c6a&scoped=true&", function () {
      api.rerender('0b502c6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Holiday/PublicHoliday/PublicHoliday.vue"
export default component.exports